'use client'
/* eslint-disable @next/next/no-img-element */
import clsx from 'clsx'
import techStackIcons, { TechStackIconName } from 'constants/techStackIcons'
import { useDeviceType } from 'hooks/useDeviceType'
import Chevron from 'public/assets/mobile-arrow-down.svg'
import { useState } from 'react'
import styles from './TechStack.module.scss'

type TechStackProps = {
  items: TechStackIconName[]
}

const TechStack = ({ items }: TechStackProps) => {
  const [collapsed, setCollapsed] = useState(true)
  const { isMobile, isTablet } = useDeviceType()

  function toggle() {
    setCollapsed(!collapsed)
  }

  return (
    <section className={styles['tech-stack']}>
      <div className={styles.content}>
        <div className={styles.title}>
          <span className={styles.text}>Tech Stack</span>
          {(isMobile || isTablet) && <Chevron className={clsx(styles.chevron, collapsed ? styles.down : styles.up)} onClick={() => toggle()} />}
        </div>
        <div className={clsx(styles.icons, collapsed ? styles.collapsed : styles.expanded)}>
          {(isMobile || isTablet) && (
            <>
              <span className={styles['collapsed-text']}>{items.join(', ')}</span>
              <>
                {items.map((item) => {
                  const icon = techStackIcons.find((x) => x.name === item)!

                  return (
                    <div key={icon.name} className={styles.icon}>
                      <img src={isTablet ? icon.tabletUrl : icon.mobileUrl} alt={icon.name} />
                      <span className={styles.tooltip}>{icon.name}</span>
                    </div>
                  )
                })}
              </>
            </>
          )}
          {!isMobile && !isTablet && (
            <>
              {items.map((item) => {
                const icon = techStackIcons.find((x) => x.name === item)!

                return (
                  <div key={icon.name} className={styles.icon}>
                    {icon.name === TechStackIconName.nodejs ? (
                      <img src={icon.desktopUrl} width={172} height={48} alt={icon.name} />
                    ) : (
                      <img src={icon.desktopUrl} alt={icon.name} />
                    )}
                    <span className={styles.tooltip}>{icon.name}</span>
                  </div>
                )
              })}
            </>
          )}
        </div>
      </div>
    </section>
  )
}

export default TechStack
